import Toastification from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Toastification, {
        timeout: 2000,
    }); // Registers the toast plugin
});